<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 数据统计 / 平台报表</span>
      </div>
      <div style="padding-top: 15px; color: #606266">
        <div>
          <h3>基础统计</h3>
        </div>
        <div style="text-align: left">
          <table width="100%">
            <tr>
              <th style="padding: 10px; background-color: #f8f8f8"></th>
              <th style="padding: 10px; background-color: #f8f8f8">入款</th>
              <th style="padding: 10px; background-color: #f8f8f8">出款</th>
              <th style="padding: 10px; background-color: #f8f8f8">发送收益</th>
              <th style="padding: 10px; background-color: #f8f8f8">新增投资</th>
              <th style="padding: 10px; background-color: #f8f8f8">新增投资额</th>
              <th style="padding: 10px; background-color: #f8f8f8">到期</th>
            </tr>
            <tr>
              <td style="padding: 10px; background-color: #f8f8f8;font-weight: bold">本月</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.month.m_topup }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.month.m_withdraw }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.month.earnings }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.month.m_invest }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.month.m_invest_price }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.month.daoqi }}</td>
            </tr>
            <tr>
              <td style="padding: 10px; background-color: #f8f8f8;font-weight: bold">历史</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.all.a_topup }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.all.a_withdraw }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.all.earnings }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.all.a_invest }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.all.a_invest_price }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ data.all.daoqi }}</td>
            </tr>
          </table>
        </div>

        <div style="padding-top: 15px;">
          <h3>未来30天数据统计</h3>
        </div>
        <div style="padding-top: 15px;">
          <div>
            <table width="100%">
              <tr>
                <th class="th">
                  日期
                </th>
                <th class="th">
                  入款
                </th>
                <th class="th">
                  出款
                </th>
                <th class="th">
                  发送收益
                </th>
                <th class="th">新增投资</th>
                <th class="th">新增投资额</th>
                <th class="th">到期本金</th>
              </tr>
              <tr :key="index" v-for="(value,index) in data.timeList">
                <td class="td">
                  {{value.day}}
                </td>
                <td class="td" style="min-width: 50px;">
                  {{ value.topUp }}
                </td>
                <td class="td">
                  {{ value.withDraw }}
                </td>
                <td class="td">
                  {{ value.earnings }}
                </td>
                <td class="td">{{ value.invest }}</td>
                <td class="td">{{ value.investPrice }}</td>
                <td class="td">{{ value.price }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";

export default {
  name: "PlatformDataTable",
  data(){
    return{
      data:null
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    axiosGet(DO_NET_URL+"dataCount/PlatformDataTable",function (res){
      res=res.data
      console.log(res)
      that.data=res
    })
  },
  methods: {
    updatePwd(){
      let that=this
      if(this.oldPwd==""){
        toask("请输入原密码！",6)
        return
      }
      if(this.newPwd==""){
        toask("请输入新密码！",6)
        return
      }
      if(this.nextPwd==""){
        toask("请再次输入新密码！",6)
        return
      }
      if(this.newPwd.length<6){
        toask("密码最少为6位！",6)
        return
      }
      if(this.newPwd!=this.nextPwd){
        toask("两次密码输入不一致！",6)
        return
      }
      loading("请求中")
      axiosPost(DO_NET_URL+"Admin/UpdatePwdByAdmin?oldPwd="+this.oldPwd+"&newPwd="+this.newPwd,"",function (res){
        closeLoading()
        if(res.code==200){
          toask("密码修改成功！",6)
          setTimeout(function (){
            that.$router.replace('index')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>